export class WebExterna {
	IdWebExterna: string;
	Nombre: string;
	Imagen: any;
	Url: string;
	ENTIDAD: any;

	Idiomas: Map<string, ContenidoWebExternaIdiomaFormulario> = new Map<string, ContenidoWebExternaIdiomaFormulario>();

	constructor(webExterna?) {
		this.Nombre = '';
		this.Imagen = null;
		this.Url = '';
		this.IdWebExterna = Guid.newGuid();

		if (webExterna) {
			this.Nombre = webExterna.Nombre;
			this.Imagen = webExterna.Imagen;
			this.Url = webExterna.Url;
			this.IdWebExterna = webExterna.Id;
			this.ENTIDAD = webExterna;

			webExterna.IDIOMAS.forEach(element => {
				const aux = new ContenidoWebExternaIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});
		}

	}

}

export class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            // tslint:disable-next-line:no-bitwise
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

export class ContenidoWebExternaIdiomaFormulario {

	Codigo: string;
	Texto: string;
	// TextoContenidos: string;

	constructor(conexionNodoIdioma?) {

		if (conexionNodoIdioma) {
			this.Codigo = conexionNodoIdioma.IDIOMA.Codigo ? conexionNodoIdioma.IDIOMA.Codigo : '';
			this.Texto = conexionNodoIdioma.Texto ? conexionNodoIdioma.Texto : '';
		}
		else{
			this.Codigo = '';
			this.Texto = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/WebExterna.ts